import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { Pageable, ResponseData, SortDirectionType } from "services/common"

export interface EmailCommunicationType {
  id: string
  sender: string | null
  status: string | null
  recipient: string | null
  bookingNumber: string | null
  from: string | null
  to: string | null
  cc: string | null
  subject: string | null
  createdDt: number | null
  pmcId: string | null
  pmsSystem: string | null
  companyName: string | null
  errorMessage: string | null
}

interface GetPaginatedEmailCommunicationDetailResponseDataData
  extends Pageable {
  content: EmailCommunicationType[]
}

interface GetPaginatedEmailCommunicationDetailResponseData
  extends ResponseData {
  data: GetPaginatedEmailCommunicationDetailResponseDataData
}

interface GetPaginatedEmailCommunicationDetailResponse extends AxiosResponse {
  data: GetPaginatedEmailCommunicationDetailResponseData
}

export interface GetPaginatedEmailCommunicationDetailRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    pageNo: number
    noOfRecords: number
    sortBy: string
    sortDirection: SortDirectionType
    keyword: string
  }
}

export function getPaginatedLogDetailApi(
  { params, ...config }: GetPaginatedEmailCommunicationDetailRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPaginatedEmailCommunicationDetailResponse> {
  return axiosInstance({
    method: "get",
    params,
    url: `newadmin/email-log/all`,
    ...config,
  })
}
